import { Link } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import { VTCartIcon } from 'vt-components'
import useGetZone from "../../../hooks/useGetZone";
import SelectLanguage from "./SelectLanguage/SelectLanguage"

//CSS
import styles from  "./header.module.less";


function Header() {

  const {i18n} = useTranslation("layout");
  const zone  = useGetZone();

  return (
    <header className={styles.header}>
      <div className={styles.headerContent}>
        <Link to={"/" + i18n.language + "/" + zone}><div className={styles.headerLogo}></div></Link>
        <div className={styles.headerEmpty}></div>
        <div className={styles.headerLanguages}>
          <SelectLanguage />
        </div>
        <div className={styles.headerCart}>
          <Link to={"/cart"}><VTCartIcon showprice={false}/></Link>
        </div>

      </div>

    </header>
  );

}

export default Header;

